module.exports = __webpack_public_path__ + "img/instagram.99ac78f1.svg";